import * as React from 'react'

import { pascalToUpperWords } from '../../utils/generic'
import { H6 } from '../texts'
import { Styled } from './styled'
import { ThemeToneFrame } from './theme-tone-frame'


export const ThemeTones = ({
  Icon,
  tones,
  themeTone,
  theme,
  changeTone
}) => (
  <Styled.ThemeTonesContainer>
    <Styled.ThemeTonesHeader>
      <Icon />
      <H6>{pascalToUpperWords(tones[0].name)}</H6>
    </Styled.ThemeTonesHeader>
    <Styled.FramesContainer>
      {tones.map(tone => (
        <ThemeToneFrame
          toneName={tone.name}
          key={tone.name}
          theme={theme}
          currentTone={themeTone === tone.name}
          backgroundColor={tone.colors.background}
          backgroundRushColor={tone.colors.backgroundRush}
          changeTone={changeTone}
        />
      ))}
    </Styled.FramesContainer>
  </Styled.ThemeTonesContainer>
)
